//Todo:After we remove the old LOI we should clean up this script and remove all code related to old loi
//IN LIT-257898 I merged list-of-issues-detailed script and add here because list-of-issues-detailed.js  is already was overriding loi.js and it was confusing
//After we remove list-of-issue folder we should copy this file with cleanup and put it under list-of-issues-detailed and modify the path for all ux3 products
import 'unfetch/polyfill/index';
(function () {
    //document.activeElement

    var $body = $('body'),
        $window = $(window);

    var loi = {
        $wrapper: null,
        $list: null,
        $loiHolder: null,
        $controls: null,
        $nextBtn: null,
        $prevBtn: null,
        $listItem: null,
        revers: false,
        isTouched: false,
        pointerPosition: 0.0,
        cumulativeShift: 0.0,
        isMobile: false,
        vPort: 'screen-sm', // default responsive break point
        year: null, // holds active year
        widgetId: null, // holds widget ID
        pagecontext: null, // holds page context
        doi: null, // holds DOI
        decade: null, // holds decade range
        wrapper: $('.loi-wrapper[data-order]'),
        targetPane: null,
        url: '/specs/products/ux3/widgets/list-of-issues/templates/list-of-issues/ajax/2009.html',
        isNewLoi: false,

        init: function () {
            loi.$wrapper = $('.swipe__wrapper');
            loi.$list = $('.loi__list');
            loi.$loiHolder = $('.dropBlock-loi__holder');
            loi.$controls =
                '<div class="loi-list__controls"><span class="loi__btn--prev"><i class="icon-arrow_l" aria-hidden="true"></i></span><span class="loi__btn--next"><i class="icon-arrow_r" aria-hidden="true"></i></span></div>';
            loi.isNewLoi = $('.loi-wrapper').hasClass('list-of-issues-detailed');
            loi.addtionalInitialization();
            loi.on.build();
            loi.control();
            loi.addtionalControls();

            $window.on('resized', function () {
                loi.on.rebuild();
            });

            $('.loi__archive').addClass('event-init');

            loi.on.pageLoad();
        },

        addtionalInitialization: function () {},

        ajaxResponse: function () {},
        control: function () {
            loi.$list.on('click', 'a', function (e) {
                loi.$listItem = $(this);
                loi.on.select();
            });

            $body.on('click', '.loi__btn--prev', function () {
                loi.$prevBtn = $(this);
                loi.on.prev();
            });

            $body.on('click', '.loi__btn--next', function () {
                loi.$nextBtn = $(this);
                loi.on.next();
            });

            $body.on('touchmove', function (e) {
                loi.on.touch.move(e);
            });

            loi.responsiveController();
            if (config.enableNewLoi && loi.isNewLoi) {
                // check if new loi or its the old one

                loi.setActiveTabsInView();
                $body.on('click', '.list-of-issues-detailed .loi__list a', function (e) {
                    //on click call
                    e.preventDefault();
                    const _this = $(this);
                    const paneSlected = _this.data('target') ? _this.data('target') : _this.attr('href');
                    if ($(paneSlected).hasClass('nested-tab')) {
                        setTimeout(function () {
                            //Need to check this code when we remove old loi
                            const loiTabNav = '> .loi > .swipe__wrapper .tab__nav';
                            loi.on.recalculate($(paneSlected).find(loiTabNav)); // to grab the first nav
                            $(paneSlected)
                                .find('.tab__pane.active')
                                .find(loiTabNav)
                                .each(function () {
                                    loi.on.recalculate($(this)); // to grab the nested navs
                                });
                        }, 50);
                    }

                    const tabTarget = _this.data('target'),
                        currentTab = $(tabTarget),
                        innerTabs = currentTab.find('.tab__nav'),
                        selectionEnd =
                            currentTab.parents('.loi-wrapper').length &&
                            currentTab.parents('.loi-wrapper').data('order') === 'ascendingOrder'
                                ? 'last'
                                : 'first';

                    if (currentTab.length && innerTabs.length) {
                        // find all tabs inside and selected actives
                        const activeTabSource = currentTab.find('.tab__nav').find('li:' + selectionEnd + '-of-type a');
                        const activeTab = activeTabSource.data('target')
                            ? activeTabSource.data('target')
                            : activeTabSource.attr('href');

                        const triggerTarget = $("[data-target='" + activeTab + "'], [href='" + activeTab + "']");
                        triggerTarget.click();
                        const scrollTarget = triggerTarget.parent().parent().closest('.scroll');
                        loi.scrollToActiveLinkInTabList(scrollTarget);
                        return;
                    }

                    loi.wrapper = _this.closest('.loi-wrapper');
                    loi.get.activeLink(_this);
                    loi.set.historyState(_this);

                    if (
                        loi.link &&
                        $('.list-of-issues-detailed').attr('data-ajax') === 'ajax' &&
                        config.enableLoiAjax
                    ) {
                        loi.load.ajax();
                    }
                });
            }
            if (config.enableOldLoi && !loi.isNewLoi) {
                // this should be removed once we replace the new loi with the old one
                $body.on('click', '.tab__nav a', function () {
                    var _this = $(this);

                    var paneSlected = _this.data('target') ? _this.data('target') : _this.attr('href');

                    if ($(paneSlected).hasClass('nested-tab')) {
                        setTimeout(function () {
                            //Need to check this code when we remove old loi
                            var loiTabNav = '> .loi > .swipe__wrapper .tab__nav';
                            loi.on.recalculate($(paneSlected).find(loiTabNav)); // to grab the first nav
                            $(paneSlected)
                                .find('.tab__pane.active')
                                .find(loiTabNav)
                                .each(function () {
                                    loi.on.recalculate($(this)); // to grab the nested navs
                                });
                        }, 50);
                    }
                });

                $body.on('click', '.loi__list a', function () {
                    let type;
                    loi.wrapper = $(this).closest('.loi-wrapper');
                    if (loi.wrapper.length === 0) {
                        loi.wrapper = $('.loi-wrapper');
                    }
                    if ($(this).closest('.tab__pane').length) {
                        loi.get.activeDecade($(this));
                        loi.get.year($(this));
                    } else {
                        loi.get.decade($(this));
                        loi.get.activeYear($(this));
                    }
                    loi.get.doi();
                    loi.get.pagecontext();
                    loi.get.url();
                    if (loi.wrapper.find('.dropBlock-loi__holder').length) {
                        type = loi.wrapper.find('.dropBlock-loi__holder').attr('data-grouptype');
                    } else {
                        type = loi.wrapper.attr('data-grouptype');
                    }
                    if (type === 'decade') {
                        if (loi.year && loi.decade && loi.pagecontext && loi.doi) {
                            loi.load.ajax();
                        }
                    }
                });
            }
        },
        responsiveController: function () {
            $(document).on(loi.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                loi.isMobile = true;
                $('.loi').addClass('loi--res'); // class will be used in our scss (to replace media queries)
                $('.loi__banner').addClass('loi--res'); // class will be used in our scss (to replace media queries)

                if ($('.corrections-container__label').length > 0) {
                    $('.corrections-container__label').addClass('w-slide__btn slide-active');
                }
                loi.setActiveTabsInView();
            });

            $(document).on(loi.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                loi.isMobile = false;
                $('.loi').removeClass('loi--res');
                $('.loi__banner').removeClass('loi--res');

                if ($('.corrections-container__label').length > 0) {
                    $('.corrections-container__label').removeClass('w-slide__btn slide-active');
                }
                loi.setActiveTabsInView();
            });
        },
        scrollToActiveLinkInTabList: function ($tabListScrollElement) {
            setTimeout(function () {
                var $listItem = $tabListScrollElement.find('.tab__nav li.active');
                var isInView =
                    $listItem[0].getBoundingClientRect().left >=
                        $tabListScrollElement[0].getBoundingClientRect().left &&
                    $listItem[0].getBoundingClientRect().right <=
                        $tabListScrollElement[0].getBoundingClientRect().right;
                if (!isInView) {
                    const scrollRightDistanceToEdge =
                        $tabListScrollElement[0].getBoundingClientRect().right -
                        $listItem[0].getBoundingClientRect().right;
                    const scrollLeftDistanceToEdge =
                        $listItem[0].getBoundingClientRect().left -
                        $tabListScrollElement[0].getBoundingClientRect().left;
                    const scrollLeftValue =
                        scrollLeftDistanceToEdge >= 0
                            ? $tabListScrollElement.scrollLeft() - scrollRightDistanceToEdge + 28
                            : $tabListScrollElement.scrollLeft() + scrollLeftDistanceToEdge - 28;
                    $tabListScrollElement.animate(
                        {
                            scrollLeft: scrollLeftValue,
                        },
                        400
                    );
                }
            }, 50);
        },
        setActiveTabsInView: function () {
            loi.$list.filter(':visible').each(function (index, listElm) {
                const scrollTarget = $(listElm).parent();
                loi.scrollToActiveLinkInTabList(scrollTarget);
            });
        },
        addtionalControls: function () {},
        on: {
            select: function () {
                setTimeout(function () {
                    $('.loi__list:visible').each(function () {
                        loi.set.itemWidth($(this));
                        loi.on.recalculate($(this));
                    });
                }, 50);

                loi.setActiveTabsInView();
            },
            next: function () {
                loi.$list = loi.$nextBtn.closest('.swipe__wrapper').find('.loi__list');
                loi.$prevBtn = loi.$list.closest('.loi-list__wrapper').find('.loi__btn--prev');
                loi.$scroll = loi.$list.closest('.scroll');
                if (!loi.$nextBtn.hasClass('inactive')) {
                    loi.$scroll.stop().animate(
                        {
                            scrollLeft: '+=' + loi.get.shiftSize(),
                        },
                        400,
                        'linear',
                        function () {
                            loi.on.activeArrows();
                        }
                    );
                }
            },
            prev: function () {
                loi.$list = loi.$prevBtn.closest('.swipe__wrapper').find('.loi__list');
                loi.$nextBtn = loi.$list.closest('.loi-list__wrapper').find('.loi__btn--next');
                loi.$scroll = loi.$list.closest('.scroll');
                loi.$scroll.stop().animate(
                    {
                        scrollLeft: '-=' + loi.get.shiftSize(),
                    },
                    400,
                    'linear',
                    function () {
                        loi.on.activeArrows();
                    }
                );
            },
            touch: {
                move: function (e) {
                    if ($(e.target).closest('.loi__list').length || $(e.target).hasClass('loi__list')) {
                        loi.$list = $(e.target).closest('.loi__list');
                        loi.$wrapper = $(e.target).closest('.loi-list__wrapper');
                        loi.$nextBtn = $(e.target).closest('.loi-list__wrapper').find('.loi__btn--next');
                        loi.$prevBtn = $(e.target).closest('.loi-list__wrapper').find('.loi__btn--prev');

                        loi.on.activeArrows();
                    }
                },
            },
            escape: function () {},
            tab: function () {},
            tabRevers: function () {},
            activeArrows: function ($list) {
                const list = $list ?? loi.$list;
                const scroll = list.closest('.scroll');
                const wrapper = list.closest('.swipe__wrapper');
                const prevSelector = '.loi__btn--prev';
                const nextSelector = '.loi__btn--next';
                const direction = scroll.css('direction');
                const startBtn = wrapper.find(direction === 'ltr' ? prevSelector : nextSelector);
                const endBtn = wrapper.find(direction === 'ltr' ? nextSelector : prevSelector);
                const wrapperSize = wrapper.width() - startBtn.width();
                const size = parseInt(wrapperSize - scroll.width() + (list.width() - wrapperSize));
                const left = Math.abs(scroll.scrollLeft()); // left is actually right when the direction is rtl

                if (left > size) {
                    endBtn.addClass('inactive');
                } else {
                    endBtn.removeClass('inactive');
                }

                if (left > 1) {
                    startBtn.removeClass('inactive');
                } else {
                    startBtn.addClass('inactive');
                }
            },
            build: function () {
                loi.$wrapper = loi.$list.closest('.swipe__wrapper');
                loi.$wrapper.addClass('loi-list__wrapper');
                loi.$list.each(function (index) {
                    const loiListWidth = $(this).width();
                    if (loiListWidth > loi.$wrapper.width()) {
                        $(this).closest('.swipe__wrapper').prepend(loi.$controls);
                    }
                    loi.set.defaultInActiveControl();
                });

                loi.$nextBtn = $('.loi__btn--next');
                loi.$prevBtn = $('.loi__btn--prev');

                if ($('.journal-home').length) {
                    loi.vPort = 'screen-md';
                }
                $('.loi__list:visible').each(function () {
                    loi.set.itemWidth($(this));
                    loi.on.recalculate($(this));
                });
            },
            rebuild: function () {
                $('.loi-list__controls').remove();
                loi.$list = $('.loi__list');
                loi.$list.each(function (index) {
                    const loiListWidth = $(this).width();

                    if (loiListWidth > loi.$wrapper.width()) {
                        $(this).closest('.swipe__wrapper').prepend(loi.$controls);
                        loi.set.defaultInActiveControl();
                    } else {
                        $(this).closest('.swipe__wrapper').find('.loi-list__controls').remove();
                    }
                });
                $('.loi__list:visible').each(function () {
                    loi.set.itemWidth($(this));
                    loi.on.recalculate($(this));
                });
            },
            recalculate: function (elem) {
                elem.width(loi.get.tabNavWidth(elem));
                loi.$wrapper = elem.closest('.swipe__wrapper').addClass('loi-list__wrapper');

                if (loi.get.tabNavWidth(elem) > loi.$wrapper.width()) {
                    if (elem.closest('.swipe__wrapper').find('.loi-list__controls').length === 0) {
                        elem.closest('.swipe__wrapper').prepend(loi.$controls);
                    }
                } else {
                    elem.closest('.swipe__wrapper').find('.loi-list__controls').remove();
                }
            },

            pageLoad: function () {
                const qs = window.location.search.substr(1);
                const qsParams = {};
                qs.split('&').map(function (param) {
                    const keyVal = param.split('=');
                    qsParams[keyVal[0]] = keyVal[1];
                });

                loi.$loiHolder.each(function (index, elem) {
                    const groupType = $(elem).attr('data-grouptype');
                    const $loiBanner = $(elem).prev('.loi__banner-list');
                    let notMobile = window.innerWidth > parseInt(UX.grid.screenSm);
                    if (qsParams.year && notMobile) {
                        if (groupType === 'decade') {
                            const $yearElem = $('[data-expand=' + qsParams.year + ']', elem);
                            if ($yearElem.length) {
                                const decadeElemId = $yearElem.closest('li[role=tabpanel]').attr('id');
                                const $decadeElem = $('a[href$=#' + decadeElemId + ']', elem);
                                $('.loi__archive', $loiBanner).trigger('click');
                                if ($decadeElem.length) {
                                    $decadeElem.trigger('focus').trigger('click');
                                }
                                setTimeout(function () {
                                    $yearElem.trigger('focus').trigger('click');
                                }, 100);
                            }
                        } else if (groupType === 'year') {
                            $('.loi__archive', $loiBanner).trigger('click');
                            $('[data-expand=' + qsParams.year + ']', elem)
                                .trigger('focus')
                                .trigger('click');
                        }
                    }

                    if (qsParams.volume) {
                        if (groupType === 'volume') {
                            $('.loi__archive', $loiBanner).trigger('click');
                            $('[data-expand=' + qsParams.volume + ']', elem).trigger('click');
                        }
                    }
                });
            },
        },
        load: {},
        get: {
            tabNavWidth: element => element.find('li').outerWidth(true) * element.find('li').length,
            year: function (element) {
                // get year from selected
                loi.year = element.find('span').text();
                loi.targetPane = element.attr('href');
            },
            activeDecade: function (element) {
                // get active decade based on selected element
                var parent = element.closest('.tab__pane').attr('aria-labelledby');
                loi.decade = $('#' + parent).data('decade')
                    ? $('#' + parent).data('decade')
                    : $('#' + parent)
                          .find('span')
                          .text();
            },
            decade: function (element) {
                // get decade from selected
                loi.decade = element.data('decade') ? element.data('decade') : element.find('span').text();
            },
            activeYear: function (element) {
                // get active year based in selected element
                var child = element.attr('href');
                loi.year = $(child).find('.loi__list').find('.active').find('span').text();
                loi.targetPane = $(child).find('.loi__list').find('.active').find('a').attr('href');
            },
            url: function () {
                if (loi.isNewLoi) {
                    loi.widgetId = $('.loi-wrapper').attr('data-db-parent-of'); //get widget ID
                    if (loi.widgetId === undefined) {
                        loi.widgetId = loi.wrapper.attr('data-widget-id'); //get widget ID
                    }
                    loi.url =
                        '/pb/widgets/loi/content?widgetId=' +
                        loi.widgetId +
                        '&pbContext=' +
                        loi.pagecontext.replace(/#/g, '%23') +
                        '&id=' +
                        loi.link; // The hash is not encoded in pbContext
                } else {
                    //This for old loi it should removed
                    loi.widgetId = loi.wrapper.attr('data-db-parent-of'); //get widget ID
                    if (loi.widgetId === undefined) {
                        loi.widgetId = loi.wrapper.attr('data-widget-id'); //get widget ID
                    }
                    loi.url =
                        '/pb/widgets/loi/loiAjax?widgetId=' +
                        loi.widgetId +
                        '&pbContext=' +
                        loi.pagecontext +
                        '&doi=' +
                        loi.doi +
                        '&decadeRange=' +
                        loi.decade +
                        '&yearParam=' +
                        loi.year; // group all needed parameters
                }
            },
            doi: function () {
                loi.doi = loi.wrapper.attr('data-journal-doi');
            },
            pagecontext: function () {
                loi.pagecontext = encodeURI($("[name='pbContext']").attr('content')); // get page context
            },
            activeLink: function (element) {
                let itemLink;
                let targetSource;
                // clicked item
                if (element.attr('data-url')) {
                    itemLink = element.attr('data-url');
                    targetSource = element.data('target');
                    loi.link = itemLink;
                    loi.targetPane = $(targetSource);
                } else {
                    //Todo:check if this code needed!
                    itemLink = element.attr('href');
                    targetSource = $(itemLink).find('.tab__nav .active a.empty');
                    loi.targetPane = targetSource.data('target')
                        ? targetSource.data('target')
                        : targetSource.attr('href');
                    loi.link = targetSource.attr('data-url');
                }
            },
            isASC() {
                return loi.wrapper?.data('order').startsWith('ascending');
            },
            shiftSize: function () {
                loi.$scroll = loi.$list.closest('.scroll');
                loi.$listItem = loi.$list.find('.tab__nav__item');
                const isOneStepSlide = loi.$list.data('one-step') === true;
                const itemWidth = loi.$listItem.outerWidth(true);
                const screenSize = loi.$scroll.width();

                return isOneStepSlide && config.enableLoiOneSlideStep ? itemWidth : screenSize;
            },
        },
        set: {
            historyState: function (element) {
                const href = element.attr('href');
                if (href) {
                    history.replaceState(null, 'loi history', href);
                }
            },
            defaultInActiveControl() {
                const btnClass = loi.get.isASC() ? 'next' : 'prev';
                const btn = loi[`${btnClass}Btn`] ?? $(`.loi__btn--${btnClass}`);
                btn?.addClass('inactive');
            },
            itemWidth: function (elem) {
                const $listItem = elem.find('.tab__nav__item');
                const $scroll = elem.parent('.scroll');
                $listItem.removeAttr('style');
                if (loi.get.tabNavWidth(elem) < loi.$wrapper.width()) return;
                const maxItemsToShow = Math.floor($scroll.width() / $listItem.outerWidth(true));
                const newItemWidth = $scroll.width() / maxItemsToShow; // Calculate item width
                $listItem.css('width', newItemWidth + 'px'); // Set item width
            },
        },
        check: {
            viewPort: function () {
                $('.loi').each(function () {
                    if ($(this).attr('data-ctrl-res')) {
                        loi.vPort = $(this).attr('data-ctrl-res');
                    }
                });
            },
        },
    };
    if (config.enableLoiAjax) {
        loi.load.ajax = function () {
            const liElement = UX.loi.targetPane[0];

            if (liElement && liElement.childNodes.length) {
                return;
            }
            const tabPane = document.querySelector('.tab__pane');
            const defaultLanguage = 'en-US,en;q=0.9';
            const options = {
                headers: {
                    'accept-language': document.documentElement.lang || defaultLanguage,
                },
            };
            if (loi.isNewLoi) {
                UX.loi.get.doi();
                UX.loi.get.pagecontext();
                UX.loi.get.url();
            }

            if (tabPane) {
                tabPane.classList.remove('loading');
                liElement.classList.add('loading');
            }

            fetch(UX.loi.url, options)
                .then(Response => {
                    Response.text().then(issue => {
                        liElement.innerHTML = issue;
                        liElement.classList.remove('loading');
                        loi.ajaxResponse();
                    });
                })
                .catch(error => {
                    console.error(error);
                    liElement.classList.remove('loading');
                });
        };
    }
    UX.loi = loi; // add to global namespace
})();
